import { render, staticRenderFns } from "./RecebimentoFiltros.vue?vue&type=template&id=24825a4e&scoped=true"
import script from "./RecebimentoFiltros.vue?vue&type=script&lang=ts"
export * from "./RecebimentoFiltros.vue?vue&type=script&lang=ts"
import style0 from "./RecebimentoFiltros.vue?vue&type=style&index=0&id=24825a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24825a4e",
  null
  
)

export default component.exports